import React from 'react';

import { Alert, Button, Stack } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import yupResolver from 'common/utils/yupResolver';

import validate from '../validate';

import Input from './Input';
import PasswordInput from './PasswordInput';

const Loginform = ({ errors, onSubmit, isLoadingSession }) => {
    const { t } = useTranslation();

    const { control, handleSubmit } = useForm({
        defaultValues: { email: '', password: '' },
        resolver: yupResolver(validate),
    });

    return (
        <Stack component="form" onSubmit={handleSubmit(onSubmit)}>
            <Input
                control={control}
                label={t('Email')}
                name="email"
                type="email"
            />

            <PasswordInput
                control={control}
                label={t('Password')}
                name="password"
            />

            {errors &&
                errors.map((error, index) => (
                    <Alert key={`error-login-${index}`} severity="warning">
                        <small>{`*${error}`}</small>
                    </Alert>
                ))}

            <Button disabled={isLoadingSession} fullWidth type="submit">
                {isLoadingSession ? t('Loading') : t('Log in')}
            </Button>
        </Stack>
    );
};

Loginform.propTypes = {
    errors: PropTypes.array,
    onSubmit: PropTypes.func,
    isLoadingSession: PropTypes.bool,
};

export default Loginform;
